import React from 'react';
import Logo from '../components/Logo';

const WHATSAPP = 'https://wa.me/541136887781';
const INSTAGRAM = 'https://www.instagram.com/argendabot/';
const FACEBOOK = 'https://www.facebook.com/profile.php?id=61591574085181';

/**
 * Servicios reales, sacados de los 3 bots del proyecto:
 *   - quilmes-turnos-licencia
 *   - alquileres-quilmes-berazategui
 *   - empleos-argentina
 */
const SERVICIOS = [
  {
    titulo: 'Turnos de licencia — Quilmes',
    descripcion:
      'Vigila el calendario de turnos de licencia de conducir de la Municipalidad de Quilmes y te avisa apenas se habilita un cupo. No reserva: solo notifica.',
  },
  {
    titulo: 'Alquileres — Quilmes y Berazategui',
    descripcion:
      'Sigue los alquileres de Argenprop (departamentos y casas) en Quilmes y Berazategui, y te manda los avisos nuevos por Telegram. Nunca repite un aviso.',
  },
  {
    titulo: 'Empleos — Argentina',
    descripcion:
      'Monitorea las últimas ofertas publicadas en Computrabajo Argentina y te avisa de las nuevas al instante, sin repetir ninguna.',
  },
];

export default function Landing() {
  return (
    <main className="lp">
      {/* ---------------------------------------------------------------- HERO */}
      <header className="hero" id="inicio">
        <nav className="nav" aria-label="Principal">
          <span className="nav__brand">
            <Logo size={34} />
            <span>ArgendaBOT</span>
          </span>
          <a className="btn btn--sm" href={WHATSAPP} target="_blank" rel="noopener noreferrer">
            Unirse al canal
          </a>
        </nav>

        <div className="hero__inner">
          <Logo size={96} title="Logo de ArgendaBOT" />
          <h1 className="wordmark">ArgendaBOT</h1>
          <p className="hero__tagline">
            Bots que automatizan tareas y te avisan por Telegram. Vos vivís tu vida;
            ellos vigilan por vos.
          </p>
          <a className="btn btn--lg" href={WHATSAPP} target="_blank" rel="noopener noreferrer">
            Unirse al canal
          </a>
        </div>
      </header>

      {/* --------------------------------------------------------- QUÉ ES */}
      <section className="section" id="que-es" aria-labelledby="que-es-title">
        <span className="eyebrow">Qué es</span>
        <h2 id="que-es-title" className="section__title">
          Un canal de Telegram lleno de bots que trabajan por vos.
        </h2>
        <p className="section__lead">
          ArgendaBOT es un canal donde ofrecemos bots que automatizan tareas repetitivas:
          vigilan sitios, trámites y convocatorias, y te avisan al instante apenas pasa
          algo que te importa. Nada de estar refrescando páginas todo el día. Ya tenemos
          tres funcionando y sumamos más seguido.
        </p>
      </section>

      {/* ----------------------------------------------------- SERVICIOS */}
      <section className="section" id="servicios" aria-labelledby="servicios-title">
        <span className="eyebrow">Servicios</span>
        <h2 id="servicios-title" className="section__title">
          Lo que ya está vigilando.
        </h2>

        <div className="grid">
          {SERVICIOS.map((s) => (
            <article className="card" key={s.titulo}>
              <span className="card__dot" aria-hidden="true" />
              <h3 className="card__title">{s.titulo}</h3>
              <p className="card__text">{s.descripcion}</p>
            </article>
          ))}

          <article className="card card--soon" aria-label="Próximamente">
            <span className="card__badge">Próximamente</span>
            <h3 className="card__title">Sumamos más bots</h3>
            <p className="card__text">
              Estamos preparando nuevos servicios. ¿Querés que automaticemos algo puntual?
              Escribinos y lo evaluamos.
            </p>
          </article>
        </div>
      </section>

      {/* --------------------------------------------------------- PRECIO */}
      <section className="section" id="precio" aria-labelledby="precio-title">
        <span className="eyebrow">Precio</span>
        <h2 id="precio-title" className="section__title">
          Oferta de lanzamiento.
        </h2>

        <div className="price">
          <span className="price__tag">Pago único</span>
          <div className="price__amounts">
            <span className="price__old">
              <s>$10.000</s>
            </span>
            <span className="price__now">$2.000</span>
          </div>
          <p className="price__note">
            Pesos argentinos. Un solo pago y accedés al canal con todos los bots.
          </p>
          <a className="btn btn--lg" href={WHATSAPP} target="_blank" rel="noopener noreferrer">
            Unirse al canal
          </a>
        </div>
      </section>

      {/* --------------------------------------------------------- CONTACTO */}
      <section className="section" id="contacto" aria-labelledby="contacto-title">
        <span className="eyebrow">Contacto</span>
        <h2 id="contacto-title" className="section__title">
          Escribinos y te sumamos.
        </h2>
        <p className="section__lead">
          Contactanos por privado para unirte al canal. Respondemos por el medio que
          más te sirva.
        </p>

        <div className="contact">
          <a
            className="contact__item contact__item--primary"
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="contact__label">WhatsApp</span>
            <span className="contact__value">+54 11 3688 7781</span>
          </a>
          <a className="contact__item" href={INSTAGRAM} target="_blank" rel="noopener noreferrer">
            <span className="contact__label">Instagram</span>
            <span className="contact__value">@argendabot</span>
          </a>
          <a className="contact__item" href={FACEBOOK} target="_blank" rel="noopener noreferrer">
            <span className="contact__label">Facebook</span>
            <span className="contact__value">ArgendaBOT</span>
          </a>
        </div>
      </section>

      {/* --------------------------------------------------------- FOOTER */}
      <footer className="footer">
        <span className="footer__brand">
          <Logo size={24} />
          ArgendaBOT
        </span>
        <a className="btn btn--sm" href={WHATSAPP} target="_blank" rel="noopener noreferrer">
          Unirse al canal
        </a>
      </footer>
    </main>
  );
}
